import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=300b491c&lang=true&"
import script from "./AboutMain.vue?vue&type=script&lang=js&"
export * from "./AboutMain.vue?vue&type=script&lang=js&"
import style0 from "./AboutMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports